export const testSourceCodeMappingColumns = [
  {
    key: "row-select",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '60px'
    },
  },
  {
    display_name: "User Story Id",
    key: "userStoryId",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '10%',
      "font-weight": 600
    },
  },
  {
    display_name: "User Story Description",
    key: "userStoryDescription",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '20%',
      "font-weight": 600
    },
  },
  {
    display_name: "Test Case Id",
    key: "testCaseID",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '10%',
      "font-weight": 600
    },
  },
  {
    display_name: "Test Case Title",
    key: "testScenario",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '20%',
      "font-weight": 600
    },
  },
  {
    display_name: "Source Code Path",
    key: "sourceCodePath",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '20%',
      "font-weight": 600
    },
  },
  {
    display_name: "Method Name",
    key: "methodName",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '10%',
      "font-weight": 600
    },
  },
  {
    display_name: "Expand",
    key: "open_modal",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
      color: "white",
      width: '10%',
      "font-weight": 600
    },
    cellStyles: {
      'text-align': 'center'
    },
    _config: {
      type: "icon",
      value: "open_in_new",
      isClickable: true,
      displayInColumn: false,
    },
  }
];
